import {
  addNavMenuSection,
  registerBulkAction,
  registerFormInputComponent,
} from '@vendure/admin-ui/core';
import {
  BannerListComponent,
  BaseProductSelectorInputComponent,
  HiddenComponent,
  HighlightedPartnerComponent,
  HighlightedProductComponent,
} from './component';
import {
  DeleteBannerItemsBulkAction,
  DeleteBannersBulkAction,
} from './component/banner/banner.bulkaction';

export default [
  registerFormInputComponent('hidden-component', HiddenComponent),
  registerFormInputComponent(
    'highligted-partner-component',
    HighlightedPartnerComponent,
  ),
  registerFormInputComponent(
    'highligted-product-component',
    HighlightedProductComponent,
  ),
  registerFormInputComponent(
    'base-product-select-input',
    BaseProductSelectorInputComponent,
  ),
  registerBulkAction(DeleteBannersBulkAction),
  registerBulkAction(DeleteBannerItemsBulkAction),
  addNavMenuSection({
    id: 'grupo-loja',
    label: 'Grupo Loja',
    items: [
      {
        id: 'banners',
        label: 'Banner',
        routerLink: ['/extensions/grupo-loja/banners'],
        icon: 'image-gallery',
        requiresPermission: 'ReadBanner',
      },
      {
        id: 'baseProduct',
        label: 'Produto Base',
        routerLink: ['/extensions/grupo-loja/base-product'],
        icon: 'blocks-group',
        requiresPermission: 'ReadBaseProduct',
      },
    ],
  }),
];
